import _async_to_generator from "@swc/helpers/src/_async_to_generator.mjs";
import regeneratorRuntime from "/builds/lululemon/global-digital-tech/content-and-education/ecom-web-app/node_modules/next/dist/compiled/regenerator-runtime/runtime.js";
import Cookies from "js-cookie";
import { fetchFlagsForClient } from "@lululemon/mwa-launch-darkly";
// List of flags to fetch and manage
// Convert to dictionary if cookie names need to differ from controlling flag names
var pcmFlags = [
    "lll-pcm-gate-home",
    "lll-pcm-gate-pdp",
    "lll-pcm-gate-sc",
    "lll-pcm-gate-wl",
    "lll-pcm-gate-sg",
    "lll-pcm-gate-qvm",
    "lll-pcm-gate-gc", 
];
function initializePCMRolloutFlags() {
    return _initializePCMRolloutFlags.apply(this, arguments);
}
function _initializePCMRolloutFlags() {
    _initializePCMRolloutFlags = /**
 * Fetches flags for a client and sets/removes cookies based on their values.
 * @param {string} clientId - The client ID for which flags are fetched.
 * @description - initializePCMRolloutFlags should execute as early in the application lifecycle as possible.
 * - initializePCMRolloutFlags should execute exactly 1 time,
 * - initializePCMRolloutFlags should not execute on server.
 * - initializePCMRolloutFlags should never execute again during client side navigations.
 */ _async_to_generator(regeneratorRuntime.mark(function _callee() {
        var clientId, allFlags, _args = arguments;
        return regeneratorRuntime.wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    clientId = (_args.length > 0 && _args[0] !== void 0 ? _args[0] : {}).clientId;
                    if (!(typeof document === "undefined")) {
                        _ctx.next = 3;
                        break;
                    }
                    return _ctx.abrupt("return");
                case 3:
                    if (clientId) {
                        _ctx.next = 6;
                        break;
                    }
                    console.error("PCMRollout:  No clientId for fetching flags");
                    return _ctx.abrupt("return");
                case 6:
                    _ctx.prev = 6;
                    _ctx.next = 9;
                    return fetchFlagsForClient({
                        clientId: clientId
                    });
                case 9:
                    allFlags = _ctx.sent;
                    if (allFlags) {
                        _ctx.next = 13;
                        break;
                    }
                    console.error("PCMRollout: No flags were fetched for the client.", {
                        clientId: clientId
                    });
                    return _ctx.abrupt("return");
                case 13:
                    // Iterate over the target flags and manage cookies
                    pcmFlags.forEach(function(flagName) {
                        // eslint-disable-next-line security/detect-object-injection
                        var flagValue = allFlags[flagName];
                        if (flagValue === true) {
                            // Set a cookie for the flag if it's enabled
                            Cookies.set(flagName, "1", {
                                path: "/",
                                secure: true,
                                sameSite: "Strict",
                                expires: 7
                            });
                        } else {
                            // Remove the cookie for the flag if it's disabled or undefined
                            Cookies.remove(flagName, {
                                path: "/"
                            });
                        }
                    });
                    _ctx.next = 19;
                    break;
                case 16:
                    _ctx.prev = 16;
                    _ctx.t0 = _ctx["catch"](6);
                    console.error("PCMRollout: An error occurred while managing PCM flags:", _ctx.t0);
                case 19:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                6,
                16
            ]
        ]);
    }));
    return _initializePCMRolloutFlags.apply(this, arguments);
}
export { initializePCMRolloutFlags };
